export class TypeAttendance {
    name: string;
    id: number;
    code: string;
}